import linkResolver from './link-resolver';
import { htmlSerializer } from '@swegaming-ab/nuxtjs-helpers';

export default function (type, element, content, children) {
    return htmlSerializer(linkResolver, type, element, content, children);
}